export const homePageType = {
  /** 公告栏 */
  noticeBoard: 'notice_board',
  /** 分类栏 */
  category: 'category_column',
  /** 热搜 */
  topSearch: 'top_search',
  /** 导航栏 */
  nav: 'nav_column',
  /** 品牌墙 */
  brand: 'brand_column',
  /** 通栏 */
  banner: 'banner_column',
  /**  轮播专栏 */
  gallery: 'gallery_column',
  /** 轮播图 */
  galleryImage: 'gallery_image',
  /** kol专栏 */
  kol: 'kol_column',
  /** 商品墙专栏 */
  spu: 'spu_column',
  /** 金刚位 */
  king_kong: 'king_kong',
};
export const PREVIEW = 'preview';
interface PageTypeMap {
  [key: string | number]: string | undefined;
}
export const pageType: PageTypeMap = {
  1: PREVIEW,
  0: '',
};
/**首页缓存**/
export const HOMECACHEDATA: string = 'PACKAGE_CACHE_DATA';

export const homeChacheStore = {
  /**
   * 存储localStorage
   */
  setStore: (name: string, content?: string) => {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
  },
  /**
   * 获取localStorage
   */
  getStore: (name: string) => {
    if (!name) return;
    return window.localStorage.getItem(name);
  },
  /**
   * 清除localStorage
   */
  clearStore: (name: string) => {
    window.localStorage.removeItem(name);
  },
};
